module.exports = __webpack_public_path__ + "static/media/Decoration_Halloween.bfc424e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Halloween.png
// module id = 1349
// module chunks = 3